module.exports = __webpack_public_path__ + "media/images/matching-1-a00421831836a2e646e54f8423153ed9.jpg";